import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ExpertB2BDataService from "../../../services/ExpertB2B";
import { Loader } from "../../../components/Loader/Loader";
import { StarIcon } from "@chakra-ui/icons";

export const ExpertB2BView = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [row, setRow] = useState<any>();
  const { id } = useParams();
  // console.log(id);

  const fetchData = () => {
    setIsLoading(true);
    ExpertB2BDataService.getB2BExpert(String(id))
      .then((res) => {
        const data = res.data;
        setRow(data.data);
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
        console.log(e);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="main-wrapper">
      <div className="page_title py-2">B2B Expert - View</div>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="p-5">
          {row ? (
            <div className="main-section">
              <div className="row justify-content-center client-detail-sec ">
                <div className="col-sm-12 card p-3">
                  <div className="row justify-content-center">
                    <div className="col-sm-6 px-4">
                      <table className="table table-striped border-0 mt-4">
                        <tbody>
                          <tr>
                            <th>Expert id:</th>
                            <td>{row._id}</td>
                          </tr>
                          <tr>
                            <th>Name:</th>
                            <td>{row.full_name}</td>
                          </tr>
                          <tr>
                            <th>Expertise:</th>
                            <td>{row.role}</td>
                          </tr>
                          <tr>
                            <th>Email:</th>
                            <td>{row.email}</td>
                          </tr>
                          <tr>
                            <th>Phone number:</th>
                            <td>{row.phone_number}</td>
                          </tr>
                          <tr>
                            <th>Expert Level:</th>
                            <td>{row.expert_level}</td>
                          </tr>
                          <tr>
                            <th>Work Experience:</th>
                            <td>{row.work_experience}</td>
                          </tr>

                          <tr>
                            <th>Category:</th>
                            <td>{row.category}</td>
                          </tr>

                          <tr>
                            <th>Profile Links:</th>
                            <td>{row.profile_link?.join(" ") || "-"}</td>
                          </tr>

                          <tr>
                            <th>Languages:</th>
                            <td>{row.language?.join(", ") || "-"}</td>
                          </tr>

                          <tr>
                            <th>Prior Manoshala Clients:</th>
                            <td>
                              {row.prior_manoshala_clients?.length ? (
                                <ul
                                  style={{
                                    listStyle: "none",
                                    paddingLeft: "16px",
                                    margin: 0,
                                  }}
                                >
                                  {row.prior_manoshala_clients.map(
                                    (client: any, index: number) => (
                                      <li key={index}>
                                        <strong>{client.main_account}</strong>
                                        {client.client_name &&
                                          ` — ${client.client_name}`}
                                      </li>
                                    ),
                                  )}
                                </ul>
                              ) : (
                                "-"
                              )}
                            </td>
                          </tr>

                          <tr>
                            <th>Manoshala SPOC:</th>
                            <td>{row.manoshala_spoc}</td>
                          </tr>
                          <tr>
                            <th>Rating:</th>
                            <td>
                              {[1, 2, 3, 4, 5].map((star) => (
                                <StarIcon
                                  key={star}
                                  color={
                                    star <= Number(row.rating)
                                      ? "yellow.400"
                                      : "transparent"
                                  }
                                  boxSize={4}
                                />
                              ))}
                            </td>
                            {/* <td>{row.rating}</td> */}
                          </tr>

                          <tr>
                            <th>Price Range:</th>
                            <td>{row.price_range}</td>
                          </tr>
                          <tr>
                            <th>Address:</th>
                            <td>{row.address}</td>
                          </tr>
                          <tr>
                            <th>City:</th>
                            <td>{row.city}</td>
                          </tr>
                          <tr>
                            <th>State:</th>
                            <td>{row.state}</td>
                          </tr>
                          <tr>
                            <th>Country:</th>
                            <td>{row.country}</td>
                          </tr>
                          <tr>
                            <th>Pincode:</th>
                            <td>{row.pincode}</td>
                          </tr>
                          <tr>
                            <th>Account Holder Name:</th>
                            <td>{row.bank_details.account_holder_name}</td>
                          </tr>
                          <tr>
                            <th>Account Number:</th>
                            <td>{row.bank_details.account_number}</td>
                          </tr>
                          <tr>
                            <th>Bank Name:</th>
                            <td>{row.bank_details.bank_name}</td>
                          </tr>
                          <tr>
                            <th>IFSC Code:</th>
                            <td>{row.bank_details.ifsc_code}</td>
                          </tr>
                          <tr>
                            <th>Notes:</th>
                            <td>{row.note}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Loader />
          )}
        </div>
      )}
    </div>
  );
};
